export default "__VITE_ASSET__18c0984b__"